import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControlDirective } from './form-control/form-control.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [FormControlDirective],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [FormControlDirective],
})
export class DirectivesModule {}
